import { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import classnames from 'classnames';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import querySearch from 'stringquery';

import { LOCALE } from 'constants/intl-wrapper';
import { handleLanguageChange, isSllrUser, SLLR_ICON } from 'utils/helpers';
import { mediaHook } from 'customHooks';
import { sendSegment } from 'utils/segment';

import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as Language } from 'assets/bosta-icons/Language.svg';
import ShipmentBallonImage from 'assets/icons/signup-ballon.png';
import CloudImage1 from 'assets/icons/cloud-image-1.png';
import CloudImage2 from 'assets/icons/cloud-image-2.png';
import CheckImage from 'assets/icons/signin-check-image.png';
import { ReactComponent as ExternalLink } from 'assets/bosta-icons/external-link.svg';

import './RegistrationContainer.less';

const RegistrationContainer = ({
  intl,
  mobileScreenSizes: { isSmallMobileScreen },
  content,
  actionLink,
  className,
  hideTrackOrderInHeader,
  isLoading,
  tip = '',
  stepper,
  footer,
  signUpPage,
  fromSllr = false
}) => {
  useEffect(() => {
    window?.fcWidget?.hide();
  }, []);

  const isFromSllr = isSllrUser() || fromSllr;

  const onChangeLanguage = () => {
    const { lang, ...restParams } = querySearch(window.location.search);
    const changedValue = intl.locale === LOCALE.EN ? LOCALE.AR : LOCALE.EN;
    let modifiedPath;
    if (lang) {
      const modifiedQuerySearch = new URLSearchParams(restParams).toString();
      modifiedPath = `${window.location.pathname.split('/')[1]}${
        modifiedQuerySearch && `?${modifiedQuerySearch}`
      }?lang=${changedValue ? changedValue : lang}`;
    } else if (!window.location.search) {
      modifiedPath = `${window.location.pathname}?lang=${changedValue}`;
    }
    handleLanguageChange(changedValue, modifiedPath);
  };

  const handleGoToWebsitePage = () => {
    if (signUpPage) {
      sendSegment('Step1a_Create-Account-Track-link');
    } else {
      sendSegment('Step1a_Login-Track-link');
    }
    window.open(
      `https://bosta.co/${
        intl.locale === LOCALE.AR ? 'ar' : 'en'
      }/tracking-shipments`,
      '_blank'
    );
  };

  return (
    <div
      className={classnames(
        'br-registration-container',
        {
          [className]: !!className
        },
        { 'br-registration-container__with-footer': !!footer }
      )}
    >
      <div className="br-registration-container__header">
        <img
          alt="Bosta logo"
          src={SLLR_ICON({
            asComponent: false
          })}
          className="br-registration-container__logo"
        />
        {!isSmallMobileScreen && stepper}
        <span className="br-registration-container__header__action">
          {!isSmallMobileScreen && !hideTrackOrderInHeader && !isFromSllr && (
            <BRButton
              type="link-color"
              label={intl.formatMessage({ id: 'login.track_my_order' })}
              className="button-md  br-registration-container__track-order"
              suffixIcon={<ExternalLink />}
              onClick={handleGoToWebsitePage}
            />
          )}
          <BRButton
            type="link-gray"
            label={intl.locale === LOCALE.EN ? 'عربي' : 'En'}
            className="button-md br-registration-container__language-btn"
            suffixIcon={<Language />}
            onClick={onChangeLanguage}
          />
        </span>
      </div>

      <div className="br-registration-content">
        {isSmallMobileScreen && stepper}
        <div className="br-registration-form-card-container">
          <img
            src={CloudImage1}
            alt=""
            className={classnames('br-registration-content__cloud-icon-1', {
              'br-registration-content__cloud-icon-signin-1': !signUpPage
            })}
          />
          <img
            src={CloudImage2}
            alt=""
            className={classnames('br-registration-content__cloud-icon-2', {
              'br-registration-content__cloud-icon-signin-2': !signUpPage
            })}
          />
          {signUpPage ? (
            <img
              src={ShipmentBallonImage}
              alt=""
              className="br-registration-ballon-icon"
            />
          ) : (
            <img
              src={CheckImage}
              alt=""
              className="br-registration-ballon-icon check-sign-in"
            />
          )}
          <div
            className={classnames('br-registration-form-card', {
              'br-registration-form-card__signup': signUpPage
            })}
          >
            {isLoading ? (
              <div className="br-registration-container__loading">
                <Spin indicator={<LoadingOutlined />} tip={tip} />
              </div>
            ) : (
              content
            )}
            {isSmallMobileScreen && actionLink && !isLoading && (
              <div className="br-registration-action-link">{actionLink}</div>
            )}
            {!isLoading && footer}
          </div>
        </div>

        {!isSmallMobileScreen && actionLink && !isLoading && (
          <div className="br-registration-action-link">{actionLink}</div>
        )}
      </div>
    </div>
  );
};

export default withRouter(injectIntl(mediaHook(RegistrationContainer)));
